import React, { useState } from 'react';
import PostCardFilterContainer from '../PostCardFilterContainer';
import {indexWrapCss, widthCss} from "../css/Goods.style";
import Header from "../../../common/layouts/header/Header";
import Footer from "../../../common/layouts/footer/Footer";
import PostCardListMobile from "./PostCardListMobile";
import Paging from "../../../common/layouts/page/Paging";

const PostCardMobile = ({
                            postCardList,
                            currentPage,
                            totalPages,
                            onPageChange,
                            selectedGenreIndex,
                            setSelectedGenreIndex,
                            onToggleLike,
                        }: {
    postCardList: any,
    currentPage: number,
    totalPages: number,
    onPageChange: (newPage: number) => void,
    selectedGenreIndex: number,
    setSelectedGenreIndex: React.Dispatch<React.SetStateAction<number>>
    onToggleLike: (postId: string) => void;
}) => {
    const filter = ['최신순', '인기순'];
    const [search, setSearch] = useState<any>("");

    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };


    return (


        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="goods"
            />

            <div className={"flex flex-col gap-[62px] py-[120px]"}>

                <div className="flex flex-row w-full h-full gap-2 px-3">
                    {filter.map((title, idx) => (
                        <PostCardFilterContainer
                            key={idx}
                            label={title}
                            isSelected={selectedGenreIndex === idx}
                            onClick={() => setSelectedGenreIndex(idx)}

                        />
                    ))}
                </div>

                  <PostCardListMobile postCardList={postCardList} onToggleLike={onToggleLike}/>

                <Paging totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange} />


            </div>
            <Footer/>

        </div>


    );
};

export default PostCardMobile;
